import React, { useContext } from "react";
import { AuthContext } from "../../../context/context.authentication.tsx";
import Authorized from "./Authorized";
import PopUpDialog from "../PopUpDialog";
import { IconHome, IconLogout } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import { UserRole } from "../../../types/User.ts";
import { ROUTE_LANDING } from "../../../const/routes.ts";

interface ProtectedRouteProps {
  children: React.ReactNode;
  to: string;
}

const LogoutRoute: React.FC<ProtectedRouteProps> = ({ children, to }) => {
  const { logout } = useContext(AuthContext)!;
  const navigate = useNavigate();

  return (
    <Authorized role={UserRole.User} ifUnauthorized={children}>
      <div className="size-full h-dvh flex justify-center items-center">
        <fieldset className="fieldset bg-base-200 border-base-300 rounded-box w-xs border p-4 gap-4">
          <legend className="fieldset-legend">Ausloggen?</legend>
          <Link to={to} className="btn btn-neutral">
            <IconHome />
            Weiter
          </Link>
          <PopUpDialog
            title={
              <>
                <IconLogout /> Ausloggen
              </>
            }
            id={`dialog-logout`}
            loading={false}
            onClick={() => {
              logout();
              navigate(ROUTE_LANDING);
            }}
            description="Willst du dich auf diesem Gerät abmelden?"
            className="btn btn-error list-col-grow"
          >
            <IconLogout />
            Ausloggen
          </PopUpDialog>
          <p className="label">Du kannst dich hier ausloggen</p>
        </fieldset>
      </div>
    </Authorized>
  );
};

export default LogoutRoute;
